































import { computed, defineComponent } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    roundedScore: {
      type: String,
      default: '',
    },
    isSpSmallStar: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // 小数部分を表す星アイコンの計算
    const computedStarIcon = computed(() => {
      if (!props.roundedScore) return;
      const fraction = props.roundedScore.charAt(props.roundedScore.length - 1);
      switch (fraction) {
        case '0':
          return;
        case '1':
        case '2':
          return 'StarMarked25';
        case '3':
        case '4':
        case '5':
          return 'StarMarked50';
        case '6':
        case '7':
        case '8':
          return 'StarMarked75';
        case '9':
          return 'StarMarked';
      }
    });

    return { computedStarIcon };
  },
});
